var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn"},[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":require("../../assets/images/brandCustom/btn_bg.png"),"alt":""}}),_c('div',{staticClass:"img-click animate img-click1",on:{"click":_vm.handleUrl}}),_c('div',{staticClass:"img-click animate img-click3",on:{"click":_vm.handleUrl}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }